let $ = jQuery

export default class Popup {
  constructor () {
    this.data = {
      ids: [],
      action: 'get_popups'
    }
    this.BUTTONS = document.querySelectorAll('[data-popup-id]:not(.single-car-modal)')
    this.WRAPPER = document.getElementById('popup-wrapper')

    this.init()
  }

  closePopup(POPUP) {
    POPUP.classList.remove('popup--show')
  }

  showPopup(POPUPMODAL) {
    POPUPMODAL.classList.add('popup--show')
  }

  onClick(BUTTON) {
    BUTTON.addEventListener('click', (e) => {
      e.preventDefault()
      let POPUPMODAL = document.getElementById('popup-' + BUTTON.dataset.popupId)
      this.showPopup(POPUPMODAL)
    })
  }

  close() {
    let CLOSEBUTTONS = document.querySelectorAll('.popup__close')
    let popups = document.querySelectorAll('.popup')
    if(CLOSEBUTTONS.length > 0) {
      for (let i = 0; i < CLOSEBUTTONS.length; i++) {
        const CURRENTBUTTON = CLOSEBUTTONS[i]
        let POPUP = document.getElementById(CURRENTBUTTON.dataset.closeId)
        CURRENTBUTTON.addEventListener('click', () => {
          this.closePopup(POPUP)
        })
        document.addEventListener('keydown', (e) => {
          if(e.key == "Escape") {
            this.closePopup(POPUP)
          }
        })
      }
    }
  }

  init() {
    if(this.BUTTONS.length) {
      for (let i = 0; i < this.BUTTONS.length; i++) {
        this.data.ids.push(this.BUTTONS[i].dataset.popupId)
        this.onClick(this.BUTTONS[i])
      }
    }

    if(this.data.ids.length > 0) {
      this.doAjax()
    }
  }

  initContactForm() {
    document.querySelectorAll(".popup .wpcf7 > form").forEach((
        function(e){
          return wpcf7.init(e)
        }
      )
    );
  }

  doAjax(ids) {

    $.post(main_theme_objects.ajax_url, this.data, (response) => {
      if (response != 0) {
        this.WRAPPER.innerHTML = response.markup
        this.close()
        this.initContactForm()
      }
    });
  }
}


